import useBookInfo from "../../bookinfo/useBookInfo";
import { VBKType } from "../../../api/features/bookinfo/types";
import useLab from "../../labs/useLab";
import { LabIds } from "../../../api/features/user/utils";
import { useBrand } from "../../../../../../common/providers/brand/brand-context";
import {
  combineDetailedStatuses,
  DetailedLoadStatus,
} from "../../../../../../common/utils/async-status";
import useUser from "../../user/useUser";

export default function usePaginationSupport() {
  const { bookInfo, loadStatus: bookLoadStatus } = useBookInfo();
  const { loadStatus: userLoadStatus } = useUser();
  const { isEnabled } = useLab();
  const brand = useBrand();

  const loadStatus = combineDetailedStatuses([bookLoadStatus, userLoadStatus]);

  if (loadStatus !== DetailedLoadStatus.OK) {
    // caller responsible for making sure data loaded
    return {};
  }

  const isSupported =
    bookInfo.vbkType === VBKType.EPUB &&
    !bookInfo.isFixedLayout &&
    brand.getProp("Labs.enabled");
  return {
    paginationSupported: !!isSupported,
    paginationActive: isSupported && isEnabled(LabIds.PAGINATION),
  };
}
